import { Fragment, memo, PropsWithChildren } from 'react';
import { List } from '@mui/material';
import { selectPackages } from 'entities/mine-package/model';
import { ReferralInfo } from 'entities/referrer/model';
import { useShallowSelector } from 'shared';

import { ReferralItem } from './components';

export const ReferralList = memo(({ children }: PropsWithChildren) => {
  return (
    <List
      sx={{
        padding: 0,
        paddingRight: 1.5,
        overflowY: 'scroll',
        overflowX: 'hidden',
        maxHeight: 210,
        '& .MuiListItem-root': {
          marginBottom: 1.75,
          '&:last-child': {
            marginBottom: 0,
          },
        },
      }}
    >
      {children}
    </List>
  );
});

interface ReferralItemsListProps {
  data: ReferralInfo[];
  loadMoreRef: (node?: Element | null | undefined) => void;
}

export const ReferralItemsList = memo(({ data, loadMoreRef }: ReferralItemsListProps) => {
  const packages = useShallowSelector(selectPackages);

  return (
    <>
      {data.map((referral, idx) => {
        const isLastItem = idx === data.length - 1;
        return (
          // eslint-disable-next-line react/no-array-index-key
          <Fragment key={`${referral.referral}-${referral.TAP2MINEId}-${referral.amount}-${idx}`}>
            <ReferralItem {...referral} packageName={packages[referral.TAP2MINEId].name} />
            {isLastItem && <div ref={loadMoreRef} style={{ width: '100%', height: '1px' }} />}
          </Fragment>
        );
      })}
    </>
  );
});
